<script>
    import { defineComponent, h } from 'vue';

    import RemoteContentLink from './RemoteContentLink.vue';

    export default defineComponent({
        name: 'RemoteContent',
        props: {
            value: {
                type: String,
                required: true,
            },
            dealer: {
                type: Object,
                default: () => {},
            },
            ticketData: {
                type: Object,
                default: () => {},
            },
        },
        methods: {
            getVNodes(nodes) {
                const children = Array.from(nodes);

                return children
                    .map((child) => {
                        if (child.nodeName === 'A') {
                            return h(
                                RemoteContentLink,
                                {
                                    href: child.href,
                                    target: child.target,
                                    dealer: this.dealer,
                                    ticketData: this.ticketData,
                                },
                                () => this.getVNodes(child.childNodes)
                            );
                        }
                        if (child.nodeType === Node.TEXT_NODE) {
                            return h('span', {}, child.textContent);
                        }
                        if (child.nodeType === Node.ELEMENT_NODE) {
                            return h(
                                child.nodeName.toLowerCase(),
                                { class: child.className },
                                this.getVNodes(child.childNodes)
                            );
                        }
                        return null;
                    })
                    .filter(Boolean); // Remove null/undefined entries
            },
        },
        render() {
            const tempElem = document.createElement('div');
            tempElem.innerHTML = this.value;
            const vNodes = this.getVNodes(tempElem.childNodes);
            return h('div', { class: 'remote-content' }, vNodes);
        },
    });
</script>

<style lang="scss" scoped>
    .remote-content-link {
        display: inline-block;
    }
</style>
